import apiPaths from '../api-paths';

export default {
  show() {
    return axios.get(`${ apiPaths.API }/bookkeepings/work-parameters/evidence-from-invoice-without-template`);
  },
  store(data) {
    return axios.post(`${ apiPaths.API }/bookkeepings/work-parameters/evidence-from-invoice-without-template`, data);
  },
};
